import { render, staticRenderFns } from "./EditSingleArticleSection.vue?vue&type=template&id=68dd8021"
import script from "./EditSingleArticleSection.vue?vue&type=script&lang=ts"
export * from "./EditSingleArticleSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports